import axios from 'axios';
import Cookies from 'js-cookie';

export const createApiAxios = (url: string, version: string = '/v1') => {
  const baseURL = `${url}${version}`;
  const apiAxios = axios.create({
    baseURL,
    withCredentials: true,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  apiAxios.interceptors.request.use((request) => {
    const bearerToken = Cookies.get('accessToken');

    if (bearerToken && request && request.headers) {
      request.headers.Authorization = bearerToken;
    }

    return request;
  });

  return apiAxios;
};
